import { z } from "zod";

const depositModalParams = z.looseObject({
  transactionId: z.string().optional(),
  return: z.string().optional(),
  cancel: z.coerce.boolean().optional(),
  depositModal: z.coerce.boolean().optional(),
  // which deposit method owns the redirect return
  method: z.string().optional(),
});

type DepositModalParams = z.infer<typeof depositModalParams>;

/**
 * Whether the url carries an off-site redirect return. The modal uses this to
 * decide it must be open and the wizard uses it to decide it must consume and
 * clear — they have to agree, or params get cleared by a modal that never
 * opened, or an outcome never gets shown.
 */
const hasDepositReturnParams = ({
  return: hasReturned,
  cancel,
  transactionId,
  method,
}: Partial<DepositModalParams>) => {
  return Boolean(hasReturned || cancel || transactionId || method);
};

export { depositModalParams, type DepositModalParams, hasDepositReturnParams };
